const isScrollable = (element: HTMLElement): boolean => {
	const overflowY = window.getComputedStyle(element).overflowY;
	return (overflowY === 'auto' || overflowY === 'scroll') && element.scrollHeight > element.clientHeight;
};

// The nearest ancestor that actually scrolls - the design-system Scrollbar wrapping the task modal's
// body. Read from the DOM rather than handed down as a ref, so it is whatever element is really
// scrolling at the time, not whichever one was expected to.
export function findScrollContainer(node: HTMLElement): HTMLElement | null {
	let current = node.parentElement;
	while (current) {
		if (isScrollable(current)) return current;
		current = current.parentElement;
	}
	return null;
}

// Puts the node in the vertical middle of its scroll container. A node taller than the container is
// aligned to its top instead: centring it would scroll the start of the answer out of view, and the
// start is where reading it begins.
export function centreInScrollContainer(node: HTMLElement): void {
	const container = findScrollContainer(node);
	if (!container) return;
	const nodeRect = node.getBoundingClientRect();
	const containerRect = container.getBoundingClientRect();
	const offsetWithinContainer = nodeRect.top - containerRect.top;
	const centringGap = Math.max(0, (containerRect.height - nodeRect.height) / 2);
	const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
	const targetScrollTop = container.scrollTop + offsetWithinContainer - centringGap;
	container.scrollTop = Math.min(Math.max(0, targetScrollTop), maxScrollTop);
}
